import React from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom"

import {Authentication} from "../../model/Authentication";
import {LogoutCompleted} from "../../model/LogoutCompleted";
import {AppError} from "../../model/AppError";
import AppHeader from "./app-header";
import {AppLayoutContext} from "./app-layout-context";
import MyLicenses from "../pages/my-licenses";
import Logout from "../pages/logout";

import "./App.scss";
import Notifications from "../components/notifications-outlet";
import AppFooter from "./app-footer";

export interface AppContainerProps {
  reactAppBasePath: string;
  headerHeight: number|undefined,
  setHeaderHeight: (n?:number|undefined) => void,
}

export interface AppReduxProps {
  isReady: boolean,
  errors?: AppError<any>[]|undefined,
  auth?: Authentication,
  logoutCompleted?: LogoutCompleted,
}
export interface AppProps extends AppContainerProps, AppReduxProps {
  externalLogout?: boolean;
}
function App(props: AppProps) {
  const {
    auth,
    logoutCompleted,
    errors,
    reactAppBasePath,
    externalLogout,
    headerHeight,
      isReady,
    setHeaderHeight,
  } = props;

  return (
    <div
        data-iframe-height
        className="App"
        data-testid="App"
    >
      <AppLayoutContext.Provider value={{ headerHeight, setHeaderHeight }}>
        <Notifications>
          <BrowserRouter basename={reactAppBasePath} key={reactAppBasePath}>
            <Routes>
              {!auth && logoutCompleted && (
                <Route
                    path="/logout"
                    element={(<Logout auth={auth}/>)}
                />
              )}
              {!auth && !logoutCompleted && errors && (
                <Route
                    path="*"
                    element={(<>
                      <h1>Errors</h1>
                      <div>{errors?.map((e) => e.errorId)}</div>
                    </>)}
                />
              )}
              {auth && (
                  <Route
                      path="*"
                      element={(<MyLicenses auth={auth}/>)}
                  />
              )}
            </Routes>
            {/* unorthodox order allows for a specific content/page to override header styles with adjacent sibling selector */}
            <AppHeader auth={auth} externalLogout={externalLogout}/>
            <AppFooter />
          </BrowserRouter>
        </Notifications>
      </AppLayoutContext.Provider>
    </div>
  );
}

export default App;
